import { ActionIcon, Avatar, Badge, Group, Stack, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { iconProps } from 'components/icon-props';
import { i18nKeys, useTranslation } from 'locales';
import { ThreadMessageHeadersHover } from './ThreadMessageHeadersHover';
import { useThreadMessage } from './useThreadMessage';

export const ThreadMessageHead = () => {
  const { t } = useTranslation();
  const { isOutbound, senderName, dateLabel, onCollapse } = useThreadMessage();

  const badgeColor = isOutbound ? 'blue' : 'violet';
  const badgeLabel = t(
    isOutbound
      ? i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.BADGE_SENT
      : i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.BADGE_INBOUND,
  );

  return (
    <Group
      p="space4"
      gap="space3"
      wrap="nowrap"
      align="flex-start"
      bg="gray.0"
      onClick={onCollapse}
      style={{ cursor: 'pointer' }}
    >
      <Avatar name={senderName} size={36} radius="xl" color={isOutbound ? 'blue' : 'violet'} />
      <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
        <Group gap="space2">
          <Text fw={500} size="sm">
            {senderName}
          </Text>
          <Badge size="xs" variant="light" color={badgeColor}>
            {badgeLabel}
          </Badge>
        </Group>
        <ThreadMessageHeadersHover />
      </Stack>
      <Stack gap={2} align="flex-end">
        <Text size="xs" c="dimmed">
          {dateLabel}
        </Text>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          onClick={event => {
            event.stopPropagation();
            onCollapse();
          }}
          aria-label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.COLLAPSE)}
        >
          <IconChevronDown {...iconProps(14)} />
        </ActionIcon>
      </Stack>
    </Group>
  );
};
